import styles from './Form.module.css';
import { classList } from '../../helpers/classList';

export interface FormProps {
  onSubmit: () => void;
  className?: string;
  children: any;
}

export const Form = ({ onSubmit, className, children }: FormProps) => {
  return (
    <form className={classList(styles.form, className)} onSubmit={onSubmit}>
      {children}
    </form>
  );
};
